module.exports = __webpack_public_path__ + "static/archZoopayLogo-f1a90cffaaa28a6299b5a9b10ce3d10a.svg";